<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-text>
        <div class="sea-plus-large-icon" :style="{ 'background-image': 'url(\'/ic-sea-plus-large.png\')' }"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { firebaseAuth } from '@/services/firebase'
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'

const userStore = createNamespacedHelpers('user')

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton },
  methods: {
    ...userStore.mapActions(['signOutUser'])
  },
  mounted() {
    firebaseAuth.signOut().then(async () => {
      await this.signOutUser()
      this.$router.replace('/')
    })
  }
}
</script>
